import ParentShop from '@components/old_pp/parents/ParentShop'
import { requireRouteAudience } from '@services/router/routeAccess'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/parent-shop')({
    component: ParentShop,
    beforeLoad: requireRouteAudience(['parent']),
})